import getImgixSrc from './getImgixSrc';

export { getImgixSrc };
